/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-21 15:54:46
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-07-03 15:39:13
 * @FilePath: \baishu_react_ui\src\components\BsyLinkData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";

import { BsyWidget } from "../BsyWidget";
import "./index.css";
import BsyFormLoadData from "../BsyFormLoadData";
import { BsyUtils } from "../../utils/Utils";

export default class BsyDataLoad extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-data-load",
      allowBlank: !0,
      loaddataconfig: {},
      onSetFormValue: null,
      text: React.language("data.loading"),
      width: 350,
      ...props,
    });
    this.state = {
      loaddataconfig: this.options.loaddataconfig,
      text: this.options.text,
    };
    // console.log('BsyDataLoad')
    this.value = null;
  }

  getValue = () => {
    return null;
  };

  _bindField = (field) => {
    this.field = field;
  };

  toFromData = (data) => {
    const { loaddataconfig, subformDataId, rowIdx } = this.options;
    let that = this;
    // let mapFields = loaddataconfig.mapFields;
    // let data = {};

    if (subformDataId) {
      let subform = "";
      let subrowval = {};

      BsyUtils.forEach(loaddataconfig.mapFields, function (a1, b1) {
        let ss = b1.field.split(".");
        subform = ss[0];
        if (b1.mode === "depend") {
          subrowval = {
            ...subrowval,
            [ss[1]]: data[b1.depend.field],
          };
        }
        // submap.push(b1);
      });
      let dws = [...that.formData[subform]];
      dws[rowIdx] = { ...dws[rowIdx], ...subrowval };
      return { [subform]: dws };
    }

    let mapFields = {}; //记录普通字段
    let mapSubFields = {}; //记录源数据子表单字段
    let mapSubFieldsDest = {}; //记录当前表单的子表单字段
    BsyUtils.forEach(loaddataconfig.mapFields, function (a1, b1) {
      if (b1.hasOwnProperty("depend")) {
        if (b1.depend.field.indexOf(".") > -1) mapSubFields[b1.field] = b1;
      }

      if (b1.field.indexOf(".") == -1) {
        mapFields[b1.field] = b1;
      } else {
        let ss = b1.field.split(".");
        if (!mapSubFieldsDest.hasOwnProperty(ss[0])) {
          mapSubFieldsDest[ss[0]] = [];
        }
        mapSubFieldsDest[ss[0]].push(b1);
      }
    });
    let tmp = {};

    //处理当前表字段为普通字段
    BsyUtils.forEach(mapFields, function (a1, b1) {
      if (a1.indexOf(".") == -1) {
        if (b1.hasOwnProperty("value")) {
          tmp[a1] = b1.value;
        } else if (b1.hasOwnProperty("depend")) {
          if (b1.depend.field.indexOf(".") == -1) {
            //普通字段对应普通字段
            tmp[a1] = that.restoreData(b1, data[b1.depend.field]);
          } else {
            //普通字段对应子表单
            tmp[a1] = null;
            //源码子表单字段
            let s = b1.depend.field.split(".");
            let subdata = data[s[0]];
            if (
              !BsyUtils.isObjectEmpty(subdata) &&
              !BsyUtils.isObjectEmpty(subdata[0]) &&
              !BsyUtils.isObjectEmpty(subdata[0][s[1]])
            ) {
              tmp[a1] = subdata[0][s[1]];
            }
          }
        } else tmp[a1] = null;
      }
    });

    let sublinemax = 0;
    if (!BsyUtils.isObjectEmpty(mapSubFields)) {
      BsyUtils.forEach(mapSubFields, function (a1, b1) {
        if (b1.hasOwnProperty("depend")) {
          let subs = b1.depend.field.split(".");
          sublinemax = data.hasOwnProperty(subs[0])
            ? data[subs[0]].length > sublinemax
              ? data[subs[0]].length
              : sublinemax
            : sublinemax;
        }
      });
    }
    if (sublinemax > 0) {
      //处理子表单对应子表单的场景
      for (let i = 0; i < sublinemax; i++) {
        BsyUtils.forEach(mapSubFieldsDest, function (a1, b1) {
          if (!tmp.hasOwnProperty(a1)) {
            tmp[a1] = [];
          }
          let subtmp = {};
          BsyUtils.forEach(b1, function (a2, b2) {
            let sfield = b2.field.split(".");
            if (b2.hasOwnProperty("value")) {
              subtmp[sfield[1]] = b2.value;
            } else if (b2.hasOwnProperty("depend")) {
              if (b2.depend.field.indexOf(".") == -1) {
                //普通字段对应普通字段
                subtmp[sfield[1]] = that.restoreData(b2, data[b2.depend.field]);
              } else {
                //普通字段对应子表单
                subtmp[sfield[1]] = undefined;
                //源码子表单字段
                let s = b2.depend.field.split(".");
                let subdata = data[s[0]];
                if (
                  !BsyUtils.isObjectEmpty(subdata) &&
                  !BsyUtils.isObjectEmpty(subdata[0]) &&
                  !BsyUtils.isObjectEmpty(subdata[i][s[1]])
                ) {
                  subtmp[sfield[1]] = subdata[i][s[1]];
                }
              }
            } else subtmp[sfield[1]] = null;
          });
          let subformdata = {};
          if (
            that.formData.hasOwnProperty(a1) &&
            i < that.formData[a1].length &&
            !BsyUtils.isObjectEmpty(that.formData[a1][i])
          ) {
            subformdata = that.formData[a1][i];
          }
          subtmp = { ...subformdata, ...subtmp };
          tmp[a1].push(subtmp);
        });
      }
    } else {
      //
      BsyUtils.forEach(mapSubFieldsDest, function (a1, b1) {
        if (!tmp.hasOwnProperty(a1)) {
          tmp[a1] = [];
        }
        let subtmp = {};
        BsyUtils.forEach(b1, function (a2, b2) {
          let sfield = b2.field.split(".");
          if (b2.hasOwnProperty("value")) {
            subtmp[sfield[1]] = b2.value;
          } else if (b2.hasOwnProperty("depend")) {
            if (b2.depend.field.indexOf(".") == -1) {
              //普通字段对应普通字段
              subtmp[sfield[1]] = that.restoreData(b2, data[b2.depend.field]);
            } else {
              //普通字段对应子表单
              subtmp[sfield[1]] = undefined;
              //源码子表单字段
              let s = b2.depend.field.split(".");
              let subdata = data[s[0]];
              if (
                !BsyUtils.isObjectEmpty(subdata) &&
                !BsyUtils.isObjectEmpty(subdata[0]) &&
                !BsyUtils.isObjectEmpty(subdata[0][s[1]])
              ) {
                subtmp[sfield[1]] = subdata[0][s[1]];
              }
            }
          } else subtmp[sfield[1]] = null;
        });
        let subformdata = {};
        if (
          that.formData.hasOwnProperty(a1) &&
          0 < that.formData[a1].length &&
          !BsyUtils.isObjectEmpty(that.formData[a1][0])
        ) {
          subformdata = that.formData[a1][0];
        }
        subtmp = { ...subformdata, ...subtmp };
        tmp[a1].push(subtmp);
      });
    }
    return tmp;
  };

  restoreData = (field, data) => {
    if (field.mode === "custom") {
      return field.value;
    } else {
      switch (field.type) {
        case "user":
        case "dept":
        case "usergroup":
        case "deptgroup":
        case "location":
        case "image":
        case "signature":
        case "upload":
        case "address": {
          let val = data;
          if (BsyUtils.isString(data)) {
            try {
              val = JSON.parse(data);
            } catch (error) {
              val = null;
            }
          }
          return val;
        }
        default: {
          return data;
        }
      }
    }
  };

  onDataFilter = () => {
    let t = [];
    this.filter && (t = t.concat(this.filter));
    return { filter: t, filterMap: this.filterMap, rel: this.rel || "and" };
  };

  render() {
    const {
      cssName,
      css,
      loaddataconfig,
      widgetName,
      appId,
      formId,
      entryId,
      text,
      designAppId,
      designEntryId,
      subform,
    } = this.options;
    let that = this;
    return (
      <div
        className={cssName + (subform ? " subform" : "")}
        style={css}
        ref={this.element}
      >
        <BsyFormLoadData
          loaddataconfig={loaddataconfig}
          widget={widgetName}
          appId={designAppId}
          formId={formId}
          entryId={designEntryId}
          isSubform={false}
          subform={subform}
          text={text}
          value={this.value}
          onSelectData={(e) => {
            this.value = e ? e.id || e._id : null;
            BsyUtils.applyFunc(
              this,
              this.options.onSetFormValue,
              [this.toFromData(e), null, this],
              !1
            );
            // this.props.onSetFormValue(this.toFromData(e),this.options)
          }}
          onGetFormData={() => {
            that.formData = BsyUtils.applyFunc(
              that,
              that.options.onGetFormData,
              [],
              !1
            );
            return this.props.onGetFormData();
          }}
        />
      </div>
    );
  }
}
